import React from 'react';
import EmailTemplate from '../../components/EmailTemplate';

const index = () => {
	return (
		<div>
			<EmailTemplate />
		</div>
	);
};

export default index;
